import { render, staticRenderFns } from "./mapPolygonsModal.vue?vue&type=template&id=2ce0350a&scoped=true&"
import script from "./mapPolygonsModal.vue?vue&type=script&lang=js&"
export * from "./mapPolygonsModal.vue?vue&type=script&lang=js&"
import style0 from "./mapPolygonsModal.vue?vue&type=style&index=0&id=2ce0350a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce0350a",
  null
  
)

export default component.exports